export default __webpack_public_path__ + "static/media/fidelity.30380bfe.jpg";